export default class AppRoute {

    constructor(name, params = {}, options = {}) {
        this.name = name;
        this.params = params;
        for (const [ k, v ] of Object.entries(options) ?? {}) {
            this[k] = v;
        }
    }

    static build(name, params, options) {
        return new this(name, params, options);
    }
}
